// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorite_favorite__2f5fq","content":"Favorite_content__37U82"};